module.exports = __webpack_public_path__ + "static/media/speak-out-vid-new.c0cdf24d.mp4";